export const ActionTypes = {
  GET_STOCKS_DATA: "GET_STOCKS_DATA",
  RESET_STATE: 'RESET_STATE'
};
